import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSensor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 9.99998 12 9.99998C13.1046 9.99998 14 10.8954 14 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.84247 7.96123C10.14 8.42651 10.004 9.04491 9.53875 9.34245C8.62664 9.92573 8 10.8802 8 12.0602C8 12.955 8.6048 13.9904 9.58034 14.6856C10.0301 15.0061 10.1349 15.6306 9.81438 16.0803C9.49387 16.5301 8.86943 16.6349 8.41966 16.3144C7.08304 15.3619 6 13.7813 6 12.0602C6 10.1009 7.0612 8.55284 8.46125 7.65752C8.92653 7.35997 9.54492 7.49595 9.84247 7.96123Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.1575 7.96123C13.86 8.42651 13.996 9.04491 14.4613 9.34245C15.3734 9.92573 16 10.8802 16 12.0602C16 12.955 15.3952 13.9904 14.4197 14.6856C13.9699 15.0061 13.8651 15.6306 14.1856 16.0803C14.5061 16.5301 15.1306 16.6349 15.5803 16.3144C16.917 15.3619 18 13.7813 18 12.0602C18 10.1009 16.9388 8.55284 15.5387 7.65752C15.0735 7.35997 14.4551 7.49595 14.1575 7.96123Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.83079 5.9434C7.13818 6.40223 7.01542 7.02338 6.55658 7.33077C5.06952 8.32702 4 9.99621 4 12.0945C4 13.7574 5.04811 15.5414 6.59823 16.6987C7.04079 17.029 7.13172 17.6556 6.80133 18.0982C6.47093 18.5408 5.84433 18.6317 5.40177 18.3013C3.48364 16.8693 2 14.5425 2 12.0945C2 9.25987 3.46223 6.99647 5.44342 5.66919C5.90225 5.3618 6.5234 5.48457 6.83079 5.9434Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.1692 5.9434C16.8618 6.40223 16.9846 7.02338 17.4434 7.33077C18.9305 8.32702 20 9.99621 20 12.0945C20 13.7574 18.9519 15.5414 17.4018 16.6987C16.9592 17.029 16.8683 17.6556 17.1987 18.0982C17.5291 18.5408 18.1557 18.6317 18.5982 18.3013C20.5164 16.8693 22 14.5425 22 12.0945C22 9.25987 20.5378 6.99647 18.5566 5.66919C18.0977 5.3618 17.4766 5.48457 17.1692 5.9434Z",
			fill: "currentColor"
		})
	]
});
export default SvgSensor;
